import modules from '../services/modules';

export const TOGGLE_MODULE_VISIBILITY = 'TOGGLE_MODULE_VISIBILITY';
export const PUBLIC_COURSES_REFRESHED = 'PUBLIC_COURSES_REFRESHED';

export function refreshCourses() {

    return (dispatch) => {

        function getSuccess(response) {

            dispatch(coursesRefreshed(response.data.data));
        }

        modules.getAllWithCourses()
            .then(getSuccess);
    };
}

export function coursesRefreshed(modules) {

    return {
        type: PUBLIC_COURSES_REFRESHED,
        modules
    };
}

export function toggleModuleVisibility(moduleId) {

    return {
        type: TOGGLE_MODULE_VISIBILITY,
        moduleId
    };
}


// WEBPACK FOOTER //
// ./actions/publicCourseList.js